import { Injectable } from '@angular/core';
import { createClient, SupabaseClient } from '@supabase/supabase-js';
import { environment } from '../../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class SupabaseService {
    private supabaseClient: SupabaseClient;

    constructor() {
        // Create a single instance of the Supabase client
        this.supabaseClient = createClient(
            environment.supabaseUrl,
            environment.supabaseKey,
            {
                auth: {
                    storageKey: 'sb-token',
                    storage: window.localStorage,
                    autoRefreshToken: true,
                    persistSession: true,
                    detectSessionInUrl: true,
                    // Bypass the Web Locks API (navigator.locks). Supabase's
                    // default lock throws NavigatorLockAcquireTimeoutError on
                    // every contended token-refresh tick, which Angular's
                    // zone.js surfaces as noisy unhandled rejections. A single
                    // browser tab still serializes auth calls via the client's
                    // internal queue, so dropping cross-tab locking is safe here.
                    lock: (_name: string, _acquireTimeout: number, fn: () => Promise<any>) => fn()
                }
            }
        );
    }

    // Method to access the client
    get client(): SupabaseClient {
        return this.supabaseClient;
    }
}